import { currentSelectedAccountName } from 'const/session'
import { setAppSessionItem } from './appSessionItem'

export const setSelectedAccount = (selectedAccountId: string): void => {
  const currentSelectedAccount = selectedAccountId || ''
  setAppSessionItem(currentSelectedAccountName, currentSelectedAccount)
}
